
<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" :back-level="1000" />
    <van-tabs v-model="activeTab" :swipe-threshold="5" class="toolBar" @change="onTableChange">
      <van-tab title="全部" name="ALL" />
      <van-tab title="待付款" name="WAIT_PAY" />
      <van-tab title="待收货" name="WAIT_GET" />
      <van-tab title="已完成" name="FINISH" />
      <van-tab title="已取消" name="CANCEL" />
    </van-tabs>
    <div class="topEmptyRect" />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >

      <div v-for="item in list" :key="item.orderId" class="orderRect">
        <div class="storename">
          <div class="leftIcon">
            <i class="iconfont iconshangdian" />
          </div>
          <span class="name" @click="onClick(item.orderId)">
            {{ GetSysTitle() }}
            <van-tag v-if="item.isSplitOrder" plain type="success" :color="GetColorMain()">子订单</van-tag>
          </span>
          <div class="state">
            {{ GetEnumText("Em_OrderState",item.state) }}
            <template v-if="item.state==='CANCEL'">
              <i class="iconfont iconquit" @click="onDelete(item.orderId)" />
            </template>
          </div>
        </div>
        <div v-if="item.lastExpressDate" class="traffic" @click="onClick(item.orderId)">
          <div class="leftIcon">
            <i class="iconfont iconquit" />
          </div>
          <div class="body">
            {{ item.lastExpressBody }}
            <br><span>{{ formatDate(item.lastExpressDate,"yyyy/MM/dd hh:mm:ss",false) }}</span>
          </div>
        </div>
        <div v-if="item.commoditys.length <= 1" class="icons" @click="onClick(item.orderId)">
          <van-image
            width="5em"
            height="5em"
            :src="item.commoditys[0].icon"
          />
          <div class="itemName">
            {{ item.commoditys[0].title }} <span> *{{ item.commoditys[0].num }}</span>
          </div>
        </div>
        <div v-else class="icons" @click="onClick(item.orderId)">

          <van-image
            v-for="(commodity,cIndex) in item.commoditys"
            :key="cIndex"
            width="5em"
            height="5em"
            :src="commodity.icon"
          />
        </div>
        <div class="total rigth" @click="onClick(item.orderId)">
          <template v-if="!item.secondMoney">
            <template v-if="item.state === 'CREATE'">
              共{{ item.totalNum }}件商品 应付款: <span>￥{{ (item.firstMoney.needPayMoney+item.firstMoney.payPrice).toFixed(2) }}</span>
              <div v-if="item.firstMoney.payPrice>0" class="orderAbout">(含支付手续费：￥{{ item.firstMoney.payPrice.toFixed(2) }})</div>

            </template>
            <template v-if="item.state !== 'CREATE'">
              共{{ item.totalNum }}件商品 实付款: <span>￥{{ item.firstMoney.needPayMoney.toFixed(2) }}</span>
            </template>
          </template>
          <template v-if="item.secondMoney">
            <template v-if="item.state === 'CREATE'">
              共{{ item.totalNum }}件商品 应付定金: <span>￥{{ (item.firstMoney.needPayMoney+item.firstMoney.payPrice).toFixed(2) }}</span>
              <div v-if="item.firstMoney.payPrice>0" class="orderAbout">(含支付手续费：￥{{ item.firstMoney.payPrice.toFixed(2) }})</div>
            </template>
            <template v-if="item.state === 'PAYWAIT'||item.state === 'PAY_FIRST'">
              共{{ item.totalNum }}件商品 已付定金: <span>￥{{ item.firstMoney.needPayMoney.toFixed(2) }}</span>
            </template>
            <template v-if="item.state === 'CREATE_SECOND'">
              共{{ item.totalNum }}件商品 应付尾款:
              <span v-if="item.secondMoney.currency ==='CNY'">￥{{ (item.secondMoney.needPayMoney+item.secondMoney.payPrice).toFixed(2) }}</span>
              <span v-if="item.secondMoney.currency !=='CNY'">{{ item.secondMoney.currency }}{{ item.secondMoney.needPayMoney.toFixed(2) }}</span>
              <div v-if="item.secondMoney.payPrice>0" class="orderAbout">(含支付手续费：￥{{ item.secondMoney.payPrice.toFixed(2) }})</div>

              <div v-if="item.secondMoney.startPayTime && afterDateNow(item.secondMoney.startPayTime,true)" class="orderAbout">尾款支付时间:{{ formatDate(item.secondMoney.startPayTime,"yyyy/MM/dd hh:mm") }}</div>
              <!-- <div v-if="item.secondMoney.startPayTime && item.secondMoney.lastPayTime && !afterDateNow(item.secondMoney.startPayTime) && afterDateNow(item.secondMoney.lastPayTime)" class="orderAbout">
                截止支付时间:{{ formatDate(item.secondMoney.lastPayTime,"yyyy/MM/dd hh:mm") }}
              </div> -->
              <div v-if="item.secondMoney.lastPayTime && !afterDateNow(item.secondMoney.lastPayTime,true)" class="orderAbout" :style="'color: '+GetColorMain()">已超尾款支付期限</div>
              <div class="orderAbout">已付定金：￥{{ item.firstMoney.needPayMoney.toFixed(2) }}</div>
            </template>
          </template>
          <template v-if="item.state === 'PAYWAIT_SECOND'">
            共{{ item.totalNum }}件商品 已付尾款:
            <span v-if="item.secondMoney.currency ==='CNY'">￥{{ item.secondMoney.needPayMoney.toFixed(2) }}</span>
            <span v-if="item.secondMoney.currency !=='CNY'">{{ item.secondMoney.currency }}{{ item.secondMoney.needPayMoney.toFixed(2) }}</span>
            <div class="orderAbout">已付定金：￥{{ item.firstMoney.needPayMoney.toFixed(2) }}</div>
          </template>
        </div>
        <div class="buttons rigth">
          <template v-if="item.state ==='CANCEL' || item.state === 'FINISHED' || item.state === 'REFUND'">
            <van-button size="small" round plain hairline type="danger" :color="GetColorMain()" @click="onBuyAgain(item)">再次购买</van-button>
          </template>
          <template v-if="item.state ==='FINISHED'">
            <van-button size="small" round plain hairline type="danger" :color="GetColorMain()" @click="onComment(item)">评价晒单</van-button>
          </template>
          <template v-if="item.state ==='PAYWAIT' || item.state ==='PAYWAIT_SECOND'">
            <van-button size="small" round plain hairline type="danger" :color="GetColorMain()" @click="onPay(item)">支付信息</van-button>
          </template>
          <template v-if="item.state ==='CREATE'">
            <van-button size="small" round plain hairline type="danger" :color="GetColorMain()" @click="onCancel(item)">取消</van-button>
            <van-button size="small" round plain hairline type="danger" :color="GetColorMain()" @click="onPay(item)">支付</van-button>
          </template>
          <template v-if="item.state ==='SHIPPED' || item.state === 'RECEIVED'">
            <van-button size="small" round plain hairline type="danger" :color="GetColorMain()" @click="onReceiving(item)">确认收货</van-button>
          </template>
          <template v-if="item.state ==='CREATE_SECOND' && !afterDateNow(item.secondMoney.startPayTime)">
            <van-button size="small" round plain hairline type="danger" :color="GetColorMain()" @click="onPay(item)">支付尾款</van-button>
          </template>
        </div>
      </div>
    </van-list>

  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { Button, Tab, Tabs, Image, List, Dialog, Tag } from 'vant'
import { GetEnumText, getUrlKey, formatDate, afterDateNow } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'

export default {
  components: {
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Image.name]: Image,
    [List.name]: List,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
    TopBar
  },
  data() {
    return {
      titleTop: GetSysTitle(),
      title: '我的订单',
      backurl: '/my/index',
      list: [],
      loading: false,
      finished: false,
      activeTab: 'ALL',
      search: {
        type: 'ALL',
        limit: 30,
        page: 1
      },
      buttonLoading: false
    }
  },

  created() {
    var type = getUrlKey('type')
    if (type) {
      this.search.type = type
      this.activeTab = type
    }
    this.onLoad()
  },
  methods: {
    formatDate,
    afterDateNow,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    onClick(id) {
      this.$router.push('/store/order/' + id)
    },
    onTableChange(name) {
      console.log('onTableChange', name)
      this.list = []
      this.search.page = 1
      this.finished = false
      this.search.type = name
      this.onLoad()
    },
    onLoad() {
      this.loading = true
      request({
        url: '/Store/OrderList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    },
    onDelete(item) {
      Dialog.confirm({
        title: '删除订单',
        message: '确认删除此订单?'
      }).then(() => {
        if (this.buttonLoading) {
          return
        }
        this.buttonLoading = true
        request({
          url: '/Store/OrderDelete',
          method: 'post',
          params: { orderId: item.orderId }
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          this.onTableChange(this.search.type)
        })
      })
    },
    onCancel(item) {
      Dialog.confirm({
        title: '取消订单',
        message: '确认取消此订单?'
      }).then(() => {
        if (this.buttonLoading) {
          return
        }
        this.buttonLoading = true
        request({
          url: '/Store/orderCancel',
          method: 'post',
          params: { orderId: item.orderId }
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          this.onTableChange(this.search.type)
        })
      })
    },
    onBuyAgain(item) {
      // console.log(item)
      // var data = ''
      // item.commoditys.map((item) => {
      //   data += item.commodityId + '|' + item.num + '|' + item.SpecificationMainId + '|' + (item.SpecificationOtherIds ? item.SpecificationOtherIds : '') + '|'
      // })
      // this.$router.push('/store/ordercreate?data=' + data)
      // this.$router.push('/store/item/' + item.commodityId)
    },
    onReceiving(item) {
      Dialog.confirm({
        title: '确认收货',
        message: '确认您已经收到商品?'
      }).then(() => {
        if (this.buttonLoading) {
          return
        }
        this.buttonLoading = true
        request({
          url: '/Store/OrderReceiving',
          method: 'post',
          params: { orderId: item.orderId }
        }).then(response => {
          this.buttonLoading = false
          if (!response.success) {
            return
          }
          this.$router.push('/store/orderReceiving/' + item.orderId)
        })
      })
    },
    onComment(item) {
      this.$router.push('/store/orderCommentList/' + item.orderId)
    },
    onPay(item) {
      this.$router.push('/store/pay/' + item.orderId)
    }
  }
}
</script>
<style scoped>
.orderRect
{
    margin-top: 1em;
    background-color: #fff;

}
.orderRect .storename
{
    position: relative;
    line-height: 2em;
    border-bottom: 1px solid #fafafa;
        padding: 0.5em;
}
.orderRect .storename .name{
    font-weight: 700;
     margin-left: 1.7em;
}
.orderRect .storename  .state{
    float: right;
    font-size: 0.9em;
    color: #999;
}
.orderRect .traffic{
    padding: 0.5em;
    position: relative;
}
.orderRect .traffic .body{
    margin-left: 1.7em;
}
.orderRect .traffic .body span{
    font-size: 0.9em;
}
.leftIcon{
    position: absolute;
    left: 0.7em;
    top:0.5em;
}
.orderRect .icons{
    background-color: #fafafa;
      padding: 0.5em;
      position: relative;
}
.orderRect .itemName{
    position: absolute;
    left: 6em;
    top:1.5em;
    right: 2em;
      overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.orderRect .itemName span
{
  font-weight: 700;
}
.orderRect .icons .van-image{
    margin-right:0.4em;
}
.orderRect .total{
     padding: 0.5em;
     line-height: 2em;
     border-bottom: 1px solid #fafafa;
}
.orderRect .total span{
    font-weight: 700;
}
.orderRect .buttons{
     padding: 0.5em;
}
.orderRect .buttons button{
  margin-left: 0.8em;
}
.toolBar{
  position: fixed;
  left: 0;
  top:3em;
  right: 0;
  z-index: 10;
}
.topEmptyRect{
  height: 29px;
}
.orderAbout{
  font-size: 0.6em;
  color: #999;
  line-height: 1.5em;
}
</style>
